import React, { Component } from 'react';
import _ from 'lodash';

import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Input,
	Paper,
	InputBase,
	Divider
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
} from '@material-ui/icons';
import { TAGS_MAP } from '../constant/content';


const styles = (theme: Theme) => createStyles({
	root: {
		display: 'inline-block',
		position:'relative',
	},
	paper: {
		padding: `${theme.spacing.unit / 4}px ${theme.spacing.unit / 2}px`,
		display: 'flex',
		alignItems: 'center',
		width: 384,
		height: 36,
		boxShadow: '0px 0px',
		background: '#FFFFFF',
		border: '1px solid #DCDCDC',
		boxSizing: 'border-box',
		borderRadius: 34,
		'&:hover':{
			boxShadow:'0px 6px 5px 0px rgba(0, 0, 0, 0.05)',
		},
	},
	input: {
		marginLeft: theme.spacing.unit,
		flex: 1,
		fontSize: '0.8rem',
		color: '#666666',
		'& > input': {
			fontFamily: 'Nunito',
			fontStyle: 'normal',
			fontWeight: 'normal',
			fontSize: 16,
			color: 'rgb(102 102 102)'
		}
	},
	iconButton: {
		padding: '10px 10px',
		opacity: 0.5,
		fontSize: theme.spacing.unit * 3,
		'& svg': {
			fontSize: 30
		}
	},
	searchSuggestions: {
		display:'none',
		position: 'absolute',
		left: 0,
		top:44,
		width: 100,
		minHeight: 100,
		maxHeight: 385,
		backgroundColor: '#fff',
		borderRadius: 20,
		padding:15,
		'& li' : {
			display:'grid',
			'grid-template-column':'10px calc(100% - 110px) 100px',
			alignItems: 'center',
			justifyContent: 'flex-start',
		}
	},
	searchSuggestionBox: {
		boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.12)',
		position: 'absolute',
		zIndex: -1,
		backgroundColor: '#fff',
		width: '100%',
		top: '0px',
		padding: '51px 0 20px',
		borderRadius: '20px',
		'& .light-text': {
			fontSize: '16px',
			fontWeight: 400,
			lineHeight: '137%',
			color: '#999999',
			padding: '0  15px',
		},
		'& .search-suggetion-listing': {
			listStyle: 'none',
			padding: '0 15px',
			margin: '0',
			'& .borderTop': {
				borderTop: '1px solid #E6E6E6'
			},
			'& li': {
				display: 'flex',
				alignItems: 'center',
				gap: '10px',
				padding: '10px 0',
				cursor: 'pointer',
				'& .icon-box': {
					width: '19px',
					minWidth: '19px',
					height: '19px',
					display: 'inline-flex',
					alignItems: 'center',
					justifyContent: 'center',
					alignSelf: 'flex-start'
				},
				'& p': {
					fontSize: '16px',
					fontWeight: 400,
					lineHeight: '138%',
					color: '#666666',
					margin: '0',
					width: 'calc(100% - 40px)',
					wordBreak: 'break-all',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					'& strong': {
						fontWeight: 600,
					}
				},
				'& p span': {
					display: 'inline',
					whiteSpace: 'pre-line',
					wordBreak: 'break-word'
				},
				'& .suggestion-tab': {
					border: '1px solid transparent',
					borderRadius: '30px',
					fontSize: '10px',
					fontWeight: 400,
					padding: '2px 8px',
					marginLeft: 'auto',
					whiteSpace: 'nowrap',
					textTransform: 'capitalize',
					cursor: 'pointer',
					alignSelf: 'flex-start',
					'&.assignmentsObjective': {
						borderColor: '#1D7DEA',
						color: '#1D7DEA',
					},
					'&.assignmentsSubjective': {
						borderColor: '#609B93',
						color: '#609B93',
					},
					'&.workbookObjective': {
						borderColor: '#8D4AE9',
						color: '#8D4AE9',
					},
					'&.workbookSubjective': {
						borderColor: '#9F37AE',
						color: '#9F37AE',
					},
					'&.archiveObjective': {
						borderColor: '#86A7FC',
						color: '#86A7FC',
					},
					'&.archiveSubjective': {
						borderColor: '#706233',
						color: '#706233',
					},
					'&.videos': {
						borderColor: '#424769',
						color: '#424769',
					},
					'&.note': {
						borderColor: '#C683D7',
						color: '#C683D7',
					},
					'&.formulas': {
						borderColor: '#176B87',
						color: '#176B87',
					},
					'&.audios': {
						borderColor: '#FF9800',
						color: '#FF9800',
					},
					'&.cppSubjective': {
						borderColor: '#607274',
						color: '#607274',
					},
					'&.cppObjective': {
						borderColor: '#994D1C',
						color: '#994D1C',
					},
					'&.concept': {
						borderColor: '#697D5B',
						color: '#697D5B',
					},
					'&.chapter': {
						borderColor: '#DF826C',
						color: '#DF826C',
					},
					'&.question': {
						borderColor: '#0C356A',
						color: '#0C356A',
					},
					'&.testpapers': {
						borderColor: '#89B9AD',
						color: '#89B9AD',
					},
					'&.subject': {
						borderColor: '#720455',
						color: '#720455',
					},
					'&.studymaterial': {
						borderColor: '#FFC201',
						color: '#FFC201'
					}
				}
			}
		},
		'& .search-suggetion-listing.search-listing': {
			maxHeight: 400,
			overflow: 'auto',
		}
	},
	upperBorderBox: {
		borderRadius: '20px 20px 0 0'
	},
});

//@ts-ignore
interface ContentSearchProps extends WithStyles<typeof styles> {
	classes: any,
	searchText: string,
	searchTextChanged: Function,
	recentSuggestions: any[];
	getRecentSuggestions: Function;
	clearSuggestions: Function;
	addSuggestionToPool: Function;
	searchResults: any[];
	incrementTagClickedCount: Function;
	fetchSearchDataAccordingToSelectedTag: Function,
	clearSearchData: Function,
	isSearchBoxClicked: Function,
}

interface ContentSearchState {
	searchText: string,
	lastSearchText: string
}

class ContentSearch extends Component<ContentSearchProps, ContentSearchState>{
	private debouncedSearch!: (term: string) => void;

	constructor(props: ContentSearchProps) {
		super(props);
		if (!props.searchText) {
			props = {
				...props,
				searchText: "",
			}
		}

		this.state = {
			searchText: props.searchText,
			lastSearchText: props.searchText
		}

		this.handleSearchText = this.handleSearchText.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleEnterSearch = this.handleEnterSearch.bind(this);
		this.handleSearchClose = this.handleSearchClose.bind(this);
		this.getRecentSuggestions = this.getRecentSuggestions.bind(this);
		this.debouncedSearch = _.debounce(this.handleSearch.bind(this), 300);
	}

	handleSearchText(e: any) {
		let { value } = e.target;
		this.setState({ searchText: value }, () => {
			if (this.state.searchText.length >= 3 && this.state.searchText !== this.state.lastSearchText) {
			  this.debouncedSearch(this.state.searchText);
			} else {
				this.props.clearSearchData && this.props.clearSearchData();
				if (!this.state.searchText.length) this.handleSearch();
			}
		  });
	}

	handleEnterSearch = (e: { key: string; }) => {
		if (e.key === 'Enter') {
			this.handleSearch(e);
		}
	}

	handleSearchClose(e: any) {
		let { value } = e.target;
		this.setState({ searchText: value });
		if (this.props.searchTextChanged) {
			this.props.searchTextChanged('');
		}
	}

	handleSearch(e?: any) {
		const { searchText } = this.state;
		if (this.props.searchTextChanged) {
			this.props.isSearchBoxClicked && this.props.isSearchBoxClicked();
			this.props.searchTextChanged(searchText,e);
		}
	}

	getRecentSuggestions() {
		this.props.getRecentSuggestions && this.props.getRecentSuggestions();
	}

	render() {
		const { classes, recentSuggestions, incrementTagClickedCount, clearSuggestions, addSuggestionToPool, searchResults, fetchSearchDataAccordingToSelectedTag } = this.props;
		const { searchText } = this.state;
		return (
      <>
        <div className={classes.root}>
          <Paper className={((searchResults.length && searchText.length) || recentSuggestions.length) && classes.upperBorderBox} classes={{ root: classes.paper }} elevation={1}>
            <IconButton
              className={classes.iconButton}
              aria-label="Search"
              onClick={this.handleSearch}
            >
              <img
                src="/assets/svg/myLibrary/search-icon.svg"
                alt="search-icon"
              />
            </IconButton>
            <InputBase
              className={classes.input}
              value={searchText}
              onFocus={() => { !searchText.length ? this.getRecentSuggestions() : this.handleSearch()}}
              onChange={this.handleSearchText}
              onKeyDown={this.handleEnterSearch}
              placeholder="Search"
			  onPaste={this.handleSearchText}
			  onBlur={()=> setTimeout(()=> {clearSuggestions && clearSuggestions()}, 100)}
            />

            {searchText && (
              <IconButton
                onClick={(e: any) => {
                  e.target.value = "";
                  this.handleSearchClose(e);
                }}
                className={classes.iconButton}
              >
                <CloseIcon />
              </IconButton>
            )}
          </Paper>
		{
		  ((searchResults && (searchResults || []).length))  ? 
		   (<div className={classes.searchSuggestionBox}>
			<span className="light-text">Search Results</span>
			<ul className="search-suggetion-listing search-listing">
				{
					searchResults.map((searchResult: any, index: number)=> {
					 const isNote = !!(searchResult.tagType === 'note');
					 const isTagsEqual = !!((index < searchResults.length && index > 0) && searchResult.tagType !== searchResults[index - 1].tagType);
					 const isSubTagsEqual = !!((index < searchResults.length && index > 0) && searchResult.tagSubType !== searchResults[index - 1].tagSubType);
					 const isseparator = (index !== (searchResult.length - 1)) && (isNote ? isSubTagsEqual : isTagsEqual);
					  return (
						<>
							<li onClick={(ev)=> {
								addSuggestionToPool && addSuggestionToPool(searchResult);
								incrementTagClickedCount();
								ev.stopPropagation();
								}} 
								className={isseparator ? 'borderTop' : ''}
								key={searchResult.
									tagId
									}>
								<span className="icon-box">
								<img
										src="/assets/svg/myLibrary/search-icon.svg"
										alt="search-icon"
								/>{" "}
								</span>
								<p>{ searchResult.tagDisplayName } </p>
								<span className={`suggestion-tab ${searchResult.tagType !== 'note' ? searchResult.tagType : ((searchResult.tagSubType !== '' && searchResult.tagSubType) || searchResult.tagType)}`}>
									{ searchResult.tagType !== 'note' ? TAGS_MAP[searchResult.tagType] : ((searchResult.tagSubType && TAGS_MAP[searchResult.tagSubType]) || TAGS_MAP[searchResult.tagType]) }
								</span>
							</li>

						</>
					 );
					})	
				}
			</ul>
		  </div>) : <></>
		}

          { (!searchResults.length && !searchText.length && (recentSuggestions || []).length) ?
            (<div className={classes.searchSuggestionBox}>
              <span className="light-text">Recent Search</span>
              <ul className="search-suggetion-listing search-listing">
                {recentSuggestions.map((suggestion: any) => {
                  return (
                    <li onClick={(ev) => {
							addSuggestionToPool && addSuggestionToPool(suggestion);
							incrementTagClickedCount();
							ev.stopPropagation();
						}} 
						key={suggestion._id}>
                      <span className="icon-box">
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_36187_52532)">
                            <path
                              d="M11.1943 12.5L8 9.51867V4.5H9.14286V9.076L12 11.748L11.1943 12.5Z"
                              fill="#999999"
                            />
                            <path
                              d="M8 0.5C6.93426 0.500151 5.87938 0.714159 4.89785 1.12935C3.91631 1.54454 3.02806 2.15247 2.28571 2.91714V0.5H1.14286V5.07143H5.71428V3.92857H2.90286C3.97487 2.73731 5.43027 1.95916 7.0163 1.72926C8.60232 1.49936 10.2188 1.83224 11.5849 2.67008C12.951 3.50792 13.9806 4.7978 14.4947 6.31569C15.0088 7.83358 14.975 9.48361 14.3992 10.9792C13.8234 12.4748 12.742 13.7214 11.3427 14.5027C9.94342 15.2839 8.31471 15.5504 6.73942 15.2558C5.16414 14.9612 3.7418 14.1241 2.71943 12.89C1.69706 11.6558 1.13924 10.1026 1.14286 8.5H0C0 10.0822 0.469192 11.629 1.34824 12.9446C2.22729 14.2602 3.47672 15.2855 4.93853 15.891C6.40034 16.4965 8.00887 16.655 9.56072 16.3463C11.1126 16.0376 12.538 15.2757 13.6569 14.1569C14.7757 13.038 15.5376 11.6126 15.8463 10.0607C16.155 8.50887 15.9965 6.90034 15.391 5.43853C14.7855 3.97672 13.7602 2.72729 12.4446 1.84824C11.129 0.969192 9.58225 0.5 8 0.5Z"
                              fill="#999999"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_36187_52532">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <p>{ suggestion.tagDisplayName } </p>
                      <span className={`suggestion-tab ${suggestion.tagType !== 'note' ? suggestion.tagType : ((suggestion.tagSubType !== '' && suggestion.tagSubType) || suggestion.tagType)}`} >
								{ suggestion.tagType !== 'note' ? TAGS_MAP[suggestion.tagType] : ((suggestion.tagSubType && TAGS_MAP[suggestion.tagSubType]) || TAGS_MAP[suggestion.tagType]) }
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          ): <></>}
        </div>
      </>
    );
	}
}

// @ts-ignore
export default withStyles(styles)(ContentSearch);

